import boletaApi from "./boletaApi";

export const getInteresMes = async (month) => {
  try {
    return await boletaApi.get("/interesMes", { params: { selectedMonth: month } });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
